<template>
    <div>
        <el-card>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db }">Panel</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/dashboard/' + $route.params.db + '/usuarios'}">Gestor de usuarios</el-breadcrumb-item>
                <el-breadcrumb-item>{{breadcrumb}}</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
            <br />
        <el-card>
            <el-form @submit.native.prevent="save" ref="form" label-position="top" id="user" >
                <el-row type="flex" justify="space-between">
                    <el-col :span="11">
                        <el-form-item label="Email">
                            <el-input v-model="form.user"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="11">
                        <el-form-item label="Contraseña">
                            <el-input v-model="form.pass"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row type="flex" justify="space-between">
                    <el-col :span="11">
                        <el-form-item label="Nivel de acceso">
                            <select class="select" v-model="form.level">
                                <option v-for="(l, i) in levels" :key="i" :value="l.id">{{l.level | uppercase}}</option>
                            </select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <br />
                        <p>Acceso a tablas:</p>
                        <el-checkbox-group v-model="tablesAccess" size="medium">
                            <el-checkbox-button v-for="(s, i) in getSidebar" :label="s.id" :key="i" v-if="s.visible == 1">{{s.display_name_plural}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <br />
                        <p>Acceso a componentes:</p>
                        <div v-for="(p, i) in fethPluginsProject" :key="i">
                            <br />
                            <label>{{p.name}}</label>
                            <el-checkbox-group v-model="componentsAccess[i].value" size="medium">
                                <el-checkbox-button  v-for="(o, j) in p.options" :label="o.id" :key="j">{{o[p.table_key]}}</el-checkbox-button>
                            </el-checkbox-group>
                        </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <br />
                        <label>Gestor de usuarios</label>
                        <br />

                        <el-radio-group v-model="gestorUsuarios" size="medium">
                            <el-radio-button label="1">Sí</el-radio-button>
                            <el-radio-button label="2">No</el-radio-button>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <br />
                <el-row>
                    <el-col :span="24">
                        <br />
                        <button v-if="this.showBottons" type="submit" class="el-button el-button--primary" form="user"><span>{{btn}}</span></button>
                        <el-button @click="close()">Cancelar</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
    </div>
</template>

<script>
    import sha1 from 'sha1'
    import ApiService from '@/common/api.service'    
    import { mapGetters } from "vuex"

    export default {
        name: 'acciones-usuario',

        async created(){
            await this.getPluginsProject()
            await this.getLevels()

            if(this.$route.params.id){
                this.breadcrumb = 'Edición usuario'
                this.btn = 'Actualizar'
                this.id = this.$route.params.id
                await this.getUser()
                await this.getAccess()

            }else{
                this.breadcrumb = 'Nuevo usuario'               
                this.btn = 'Crear'               
            }

        },
        data() {
            return {
                breadcrumb: false, 
                btn: false, 
                id: false, 
                
                formAPI: {
                    user: null,
                    pass: null,
                    level: 2
                },
                passOld: false,
                levelsAPI: false,
                delete: false,
                tablesAccess: [],
                componentsAccess: [],
                showBottons: true,
                tablesProjectAPI: false,
                pluginsProject: null,
                componentsAccessOptions: [],
                gestorUsuarios: 2
            }
        },
        methods: {
            save() {
                if(this.form.user  == ''){
                    this.$root.$emit('msgError','El campo Email es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }
                if(this.form.pass  == ''){
                    this.$root.$emit('msgError','El campo contraseña es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }

                if(this.error == false){
                    if(this.passOld != this.form.pass){
                        this.form.pass = sha1(this.form.pass)
                    }
                    this.id > 0 ? this.update() : this.insert() ; 
                }
            },
            async insert(){
				await ApiService.post("admin/add-user", {
                    token: localStorage.getItem("token"),
                    form: this.form
				}).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro insertado')
                        this.id = response.data
                        this.insertUserProject()
                        this.updateAccess()
                    }else{
                        this.$root.$emit('msgError', response.data)
                    }	
				});
            },
            async insertUserProject(e){
                await ApiService.post("admin/add-user-project", {
                    token: localStorage.getItem("token"),
                    form : {
                        user_id: this.id,
                        project_id: localStorage.getItem("table"),
                    } 
                })
            },
            async update(){
				await ApiService.post("admin/edit-user", {
                    token: localStorage.getItem("token"),
                    id: this.id ,
                    form: this.form
				}).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.$root.$emit('msgSuccess', 'Registro actualizado')
                        this.updateAccess()
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            },
            async updateAccess() {
                await ApiService.post("admin/update-user-access", {
                    token: localStorage.getItem("token"),
                    project: localStorage.getItem("table"),
                    id: this.id,
                    access_tables: JSON.stringify(this.tablesAccess),
                    access_components: JSON.stringify(this.componentsAccess),
                    gestor_usuarios: this.gestorUsuarios
				}).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.$root.$emit('msgSuccess', 'Registro actualizado')
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
				})
            },
            async getUser(){
				await ApiService.post("admin/user", {
                    token: localStorage.getItem("token"),
                    id: this.id
				}).then(response => {
                    this.formAPI = response.data
                    this.passOld = response.data.pass			
				});
            },
            async getAccess() {
                await ApiService.post("admin/user-access", {
                    token: localStorage.getItem("token"),
                    project: localStorage.getItem("table"),
                    id: this.id
				}).then(response => {
                    let components = []
                    response.data.access_components ? components = JSON.parse(response.data.access_components) : false;
                    this.componentsAccess.filter( e => {
                        components.filter( c => {
                            if(c.name === e.name) e.value = c.value
                        })
                    })
                    response.data.access_tables ? this.tablesAccess = JSON.parse(response.data.access_tables) : false
				})
            },

            async getLevels(){
				await ApiService.post("admin/levels", {
					token: localStorage.getItem("token")
				}).then(response => {
					this.levelsAPI = response.data;			
				});
            },

            async getPluginsProject(){
				await ApiService.post("admin/plugins-project", {
                    token: localStorage.getItem("token"),
                    project: localStorage.getItem("table")
				}).then(response => {
                    this.pluginsProject = response.data
                    this.pluginsProject.map( (p, i) => {
                        p.options = null
                        p.access = []
                        this.componentsAccess.push({name: p.name, value: [] })
                        if(p.table_name) this.getTableOptions(p.table_name, i)
                        return p
                    })
				})
            },
            async getTableOptions(table, i) {
                const response = await ApiService.post("dashboard/table", {
                    table: table,
                    token: localStorage.getItem("token"),
                    project_id: localStorage.getItem("table"),
                })
                this.pluginsProject[i].options = response.data
            }
        },
        computed: {
            form() {
                return this.formAPI
            },
            levels() {
                return this.levelsAPI
            },
            tablesProject() {
                return this.tablesProjectAPI
            },
            fethPluginsProject() {
                return this.pluginsProject
            },
            ...mapGetters(["getSidebar"])
        },
        filters: {
            uppercase: function(v) {
                return v.toUpperCase();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/forms/formUsuarios.vue